import { Auth } from '@edge/spark/io-aws'
import { MutationResolvers } from '../../../generated/graphql'
import { persistor } from '../apolloSingletons'

const doLogout: MutationResolvers['doLogout'] = async (_obj, _args, { client }) => {
    if (!client) {
        throw new Error('Missing Apollo client')
    }
    await Promise.resolve()
    await persistor.purge()
    console.log('doLogout: Signing out...')
    await Auth.signOut(undefined, { reload: false })
    return null
}

export default doLogout
